/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProductDescription from './ProductDescription/ProductDescription';
import styles from './ProductDetail.module.css';

const ProductDetails = (props) => {
  const { layout, isCollapsible, isOpen, toggleIsOpen } = props;
  const icon = isOpen ? 'fal fa-minus' : 'fal fa-plus';

  return (
    <div className={classNames(styles.details, styles[layout])}>
      <div className={styles.header}>
        <h2>Product Details</h2>
        {isCollapsible && (
          <button type="button" className="naked-button" onClick={toggleIsOpen}>
            <i className={icon} />
          </button>
        )}
      </div>
      {(!isCollapsible || isOpen) && <ProductDescription {...props} />}
    </div>
  );
};

ProductDetails.propTypes = {
  layout: PropTypes.string,
  isCollapsible: PropTypes.bool,
  isOpen: PropTypes.bool,
  shortDescription: PropTypes.string,
  includes: PropTypes.string,
  features: PropTypes.string,
  color: PropTypes.string,
  design: PropTypes.string,
  size: PropTypes.string,
  dimensions: PropTypes.string,
  howToUse: PropTypes.string,
  ingredients: PropTypes.string,
  materials: PropTypes.string,
  techCompatibility: PropTypes.string,
  careInstructions: PropTypes.string,
  pao: PropTypes.string,
  additionalInfo: PropTypes.string,
  countryOfOrigin: PropTypes.string,
  dropshipDisclaimer: PropTypes.bool.isRequired,
  paoDisclaimer: PropTypes.bool.isRequired,
  cbdDisclaimer: PropTypes.bool.isRequired,
  description: PropTypes.string,
  shortDescriptionFieldsFF: PropTypes.bool,
  toggleIsOpen: PropTypes.func,
};

ProductDetails.defaultProps = {
  layout: 'medium',
  isCollapsible: false,
  isOpen: true,
  shortDescription: null,
  includes: null,
  features: null,
  color: null,
  design: null,
  size: null,
  dimensions: null,
  howToUse: null,
  ingredients: null,
  materials: null,
  techCompatibility: null,
  careInstructions: null,
  pao: null,
  additionalInfo: null,
  countryOfOrigin: null,
  description: null,
  shortDescriptionFieldsFF: true,
  toggleIsOpen: () => {},
};

export default ProductDetails;
